import React from 'react'
import PropTypes from 'prop-types'

const Authors = (props) => {

  return (
    <span className='text-body-secondary'>
      mit {props.authors.map((author) => author.name).join(', ')}
    </span>
  )
}

Authors.propTypes = {
  authors: PropTypes.array.isRequired,
}

export default Authors
